function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#004d40",
  d: "M52.96 6.012h1.826v10.951H52.96z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M57.067 7.838a2.281 2.281 0 11-2.281 2.281 2.283 2.283 0 012.281-2.281m0-1.826a4.107 4.107 0 104.107 4.107 4.106 4.106 0 00-4.107-4.107zM38.614 14.225h-1.826V6.012h1.826zM41.166 14.225H39.34V6.012h1.826z",
  fill: "#004d40"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M34.508 7.838a2.281 2.281 0 11-2.281 2.281 2.283 2.283 0 012.281-2.281m0-1.826a4.107 4.107 0 104.107 4.107 4.106 4.106 0 00-4.107-4.107zM69.581 14.225h-1.826V6.012h1.826z",
  fill: "#004d40"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M65.474 7.838a2.281 2.281 0 11-2.281 2.281 2.283 2.283 0 012.281-2.281m0-1.826a4.107 4.107 0 104.107 4.107 4.106 4.106 0 00-4.107-4.107zM82.976 9.286v1.684h7.141l-1.415-1.684zM70.682 3.865v10.361h1.826V3.422a17.627 17.627 0 01-1.826.443zM79.565 3.891h1.826v10.335h-1.826z",
  fill: "#004d40"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M74.789 7.838a2.281 2.281 0 11-2.281 2.281 2.283 2.283 0 012.281-2.281m0-1.826a4.107 4.107 0 104.107 4.107 4.106 4.106 0 00-4.107-4.107zM87.797 11.717a2.278 2.278 0 11.489-.746h1.9a4.112 4.112 0 10-.659 1.509zM27.136 12.4a2.281 2.281 0 111.627-3.877l1.735-.759a4.107 4.107 0 100 4.716l-1.733-.762a2.268 2.268 0 01-1.629.682zM41.283 14.223h-1.964v-4.5a3.755 3.755 0 117.51 0v4.436h-1.964v-4.44a1.792 1.792 0 00-3.583 0z",
  fill: "#004d40"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M46.84 14.223h-1.964v-4.5a3.755 3.755 0 017.51 0v4.436h-1.964v-4.44a1.791 1.791 0 10-3.582 0z",
  fill: "#004d40"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.726 19.453a9.727 9.727 0 01-6.877-16.6 9.726 9.726 0 0116.6 6.878 9.65 9.65 0 01-.871 4.029h-8.82a1.853 1.853 0 010-3.706h2.753V6.493H9.758a5.41 5.41 0 100 10.82h6.055a9.683 9.683 0 01-6.086 2.14zM9.7 4.392l.6 1.038h2.133L9.7.674 6.973 5.431h2.133l.6-1.038z",
  fill: "#5fce17"
});

var SvgCampableLogo = function SvgCampableLogo(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 90.277 19.453"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

export default SvgCampableLogo;